import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-kanban',
  templateUrl: './kanban.component.html',
  styleUrls: ['./kanban.component.css']
})
export class KanbanComponent implements OnInit {

  @Input() onShowPeriod;
  @Input() onShowMenu;

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /Users/Myrberg/Documents/spring_repo1/spring-app/src/app/base/components/kanban/kanban.component.ts